export default __webpack_public_path__ + "images/YO.44ba68d.png";